import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Building2, Search } from "lucide-react";
import { residentApi, errMsg, openPdf } from "@/lib/api";
import { useResident } from "@/lib/residentAuth";
import { Card, ErrorState, ListSkeleton } from "@/components/common";
import { TenantView } from "@/components/TenantView";
import { useResidentApi } from "@/pages/resident/useResidentApi";
import { MyRequests } from "@/pages/resident/MyRequests";
import { MyVisits } from "@/pages/resident/MyVisits";

function StayHome() {
  const { data, loading, error, reload } = useResidentApi<any>("/resident/home");
  if (loading && !data) return <ListSkeleton rows={4} />;
  if (error) return <ErrorState message={error} onRetry={reload} />;
  return <TenantView d={data} onReceipt={(p) => openPdf(`/resident/receipts/${p.id}.pdf`, `${p.receipt_no}.pdf`, residentApi).catch((e) => toast.error(errMsg(e)))} />;
}

function NoStay() {
  const { resident } = useResident();
  return (
    <div className="space-y-4 pg-stagger">
      <h1 className="text-2xl font-bold">Hi{resident?.name ? `, ${resident.name}` : ""}</h1>
      <Card className="p-5 bg-[#131e2e] border-[#131e2e] text-white" data-testid="resident-nostay-card">
        <Building2 className="h-8 w-8 text-[#fccc00]" />
        <p className="mt-3 text-lg font-bold">You're not linked to a PG yet</p>
        <p className="text-sm text-[#c9dcf2] mt-1">Search PGs and request to join. Once the owner accepts, your rent, receipts and menu show up here.</p>
        <Link to="/resident/search" data-testid="resident-find-pg-btn" className="mt-4 h-12 rounded-xl bg-white text-[#131e2e] font-semibold flex items-center justify-center gap-2 pg-tap"><Search className="h-4 w-4" />Find a PG</Link>
      </Card>
      <MyVisits />
      <MyRequests />
    </div>
  );
}

export default function ResidentHome() {
  const { resident } = useResident();
  return resident?.stay ? <StayHome /> : <NoStay />;
}
